import { Location } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ModuleWithProviders, NgModule, Provider } from '@angular/core';
import {
  MSAL_GUARD_CONFIG,
  MSAL_INSTANCE,
  MSAL_INTERCEPTOR_CONFIG,
  MsalModule,
  MsalService,
} from '@azure/msal-angular';
import { IPublicClientApplication, PublicClientApplication } from '@azure/msal-browser';
import { CookieService } from 'ngx-cookie-service';
import {
  createMsalConfiguration,
  createMsalGuardConfiguration,
  createMsalInterceptorConfiguration,
} from './core-auth.config.factory';
import { CoreAuthConfig } from './core-auth.models';
import { CoreAuthInterceptor } from './core-auth.interceptor';
import { CORE_AUTH_CONFIG } from './core-auth.tokens';

const provideCoreAuth = (config: CoreAuthConfig): Provider[] => {
  return [
    {
      provide: CORE_AUTH_CONFIG,
      useValue: config,
    },
    CookieService,
    {
      provide: MSAL_INSTANCE,
      useFactory: () => new PublicClientApplication(createMsalConfiguration(config)),
    },
    {
      provide: MsalService,
      useFactory: (instance: IPublicClientApplication, location: Location) => new MsalService(instance, location),
      deps: [MSAL_INSTANCE, Location],
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: () => createMsalGuardConfiguration(config),
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: () => createMsalInterceptorConfiguration(config),
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CoreAuthInterceptor,
      multi: true,
    },
  ];
};

@NgModule({
  imports: [MsalModule],
})
export class CoreAuthModule {
  static forRoot(config: CoreAuthConfig): ModuleWithProviders<CoreAuthModule> {
    return {
      ngModule: CoreAuthModule,
      providers: provideCoreAuth(config),
    };
  }
}
